import { useMutation, useQuery } from '@tanstack/react-query'
import { i18n } from '@zet/localization'

import { useSubscriptionStore } from '../../store/subscriptionStore'
import {
  getLandingPageContent,
  getSubscriptionInfo,
  getSubscriptionStatus,
  subscribeZetPrime,
} from './functions'

function useLandingPageContent() {
  return useQuery(
    ['ZetPrimecontent', { locale: i18n.locale }],
    getLandingPageContent,
    {
      // staleTime: FIVE_MINUTES,
      // cacheTime: FIVE_MINUTES,
    },
  )
}

function useSubscribeZetPrime() {
  return useMutation(['subscribeZetPrime'], subscribeZetPrime, {})
}

function useSubscriptionInfo() {
  const { setSubscription } = useSubscriptionStore()

  return useQuery(['zet-prime', 'subscription-info'], getSubscriptionInfo, {
    // staleTime: FIVE_MINUTES,
    // cacheTime: FIVE_MINUTES,
    onSuccess: (data) => {
      setSubscription({ ...data })
    },
  })
}

function useSubscriptionStatus() {
  return useMutation(
    ['zet-prime', 'subscription-status'],
    getSubscriptionStatus,
  )
}

export {
  useLandingPageContent,
  useSubscribeZetPrime,
  useSubscriptionInfo,
  useSubscriptionStatus,
}
